import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Signal02 = function Signal02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.2427 5.7573c2.3431 2.3432 2.3431 6.1422 0 8.4853m-8.4854 0c-2.3431-2.3431-2.3431-6.1421 0-8.4853M4.9287 17.0711c-3.9052-3.9053-3.9052-10.2369 0-14.1421m14.1426 0c3.9052 3.9052 3.9052 10.2368 0 14.1421M12 12c1.1045 0 2-.8954 2-2s-.8955-2-2-2-2 .8954-2 2 .8954 2 2 2m0 0v9"
    })
  }));
};
export default Signal02;